import {
  mountCrucialReact,
  type CrucialReactProps,
} from './crucialReactMount'
import LeaderboardQuestionResponseGlobe, {
  type LeaderboardQuestionResponseGlobeProps,
} from './LeaderboardQuestionResponseGlobe'
import { renderCrucialRoot } from './renderCrucialRoot'
import { type ThemeMode, withHostTheme } from './themeHandler'

const ThemedLeaderboardQuestionResponseGlobe = withHostTheme(
  ({
    props,
    theme,
  }: {
    props: CrucialReactProps & Omit<LeaderboardQuestionResponseGlobeProps, 'theme'>
    theme: ThemeMode
  }) => <LeaderboardQuestionResponseGlobe {...props} theme={theme} />,
)

mountCrucialReact<
  CrucialReactProps & Omit<LeaderboardQuestionResponseGlobeProps, 'theme'>
>(
  'LeaderboardQuestionResponseGlobe',
  (root, props) => {
    renderCrucialRoot(
      root,
      'LeaderboardQuestionResponseGlobe',
      <ThemedLeaderboardQuestionResponseGlobe props={props} />,
    )
  },
)
